module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Review policy","review_permission":"Review permission","review_publication_period":"Review publication period","rating_criteria_and_impact":"Rating criteria and impact","review_deletion_criteria_and_appeal_procedures":"Review deletion criteria and appeal procedures"}}')
  delete Component.options._Ctor
}
